import {getTableHeaderFieldName} from '../helpers'
import {getTableMeta} from '../../../helpers'
import {Text} from '../../../../text'

export const HeaderTitle = ({value, context, infoIconMessage}) => {
	const {tableName, recordType} = getTableMeta(context)
	const name = getTableHeaderFieldName({field: value, name: tableName, recordType})
	return (
		<Text small infoIconMessage={infoIconMessage}>
			{name}
		</Text>
	)
}
